export * from './post-projekt-art.component';
export * from './post-projekt-art.component.module';